<template>
  <component
    :is="DevOrderUnitPickerFi"
    v-if="DevOrderUnitPickerFi"
    :unit="unit"
  />
  <span
    v-else
    class="preferred-order-unit-fi"
    data-test="preferred-order-unit"
  >
    {{ unit }}
  </span>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue';

import { useFischer } from '@/composables/fischerPlugin';
import { readPreferredOrderUnit } from '@/composables/preferredOrderUnit';

defineOptions({ name: 'PreferredOrderUnitFi' });

const DevOrderUnitPickerFi = IS_SHOWROOM
  ? defineAsyncComponent(
      () => import('@/components/dev/dev-order-unit-picker-fi/DevOrderUnitPickerFi.vue'),
    )
  : null;

const fischer = useFischer();

const unit = computed<string>(() => readPreferredOrderUnit(fischer));
</script>

<style scoped src="./preferred-order-unit-fi.scss" />
